import React, { createContext, useContext, useState, useEffect } from "react";
import { apiFetch, getToken, setToken, clearToken } from "../portal/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [verificat, setVerificat] = useState(false); // am verificat token-ul la pornire?

  // La pornire: dacă există token salvat, verificăm că e încă valid.
  useEffect(() => {
    const token = getToken();
    if (!token) {
      setVerificat(true);
      return;
    }
    apiFetch("/me")
      .then((data) => {
        if (data && data.ok) setClient(data.client);
        else clearToken();
      })
      .catch(() => clearToken())
      .finally(() => setVerificat(true));
  }, []);

  // Login real: apelează backend-ul, salvează token-ul.
  const login = async (email, parola) => {
    try {
      const data = await apiFetch("/login", {
        method: "POST",
        body: JSON.stringify({ email, parola }),
      });
      if (data && data.ok) {
        setToken(data.token);
        setClient(data.client);
        return { ok: true };
      }
      return { ok: false, eroare: "Email sau parolă greșite." };
    } catch (e) {
      return { ok: false, eroare: e.message || "Eroare la autentificare." };
    }
  };

  const logout = () => {
    clearToken();
    setClient(null);
  };

  return (
    <AuthContext.Provider value={{ client, login, logout, verificat }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
